import Vue from "vue";
import ActionCableVue from "actioncable-vue";

const token = localStorage.getItem("token");
const connectionUrl =
  location.origin.replace("http", "ws") +
  "/cable" +
  (token ? `?token=${token}` : "");

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: "error",
  connectionUrl,
  connectImmediately: false,
});
